import React from 'react';
import Button from '../Button';
import BaseModal from './BaseModal';
import {ISearchQueue} from '../../Foundations/Types/ISearchContext';
import { History } from 'history';
import APP_PATH from '../../Foundations/Constants/AppPath';

interface IProps {
    queue: ISearchQueue,
    hide(): void;
    history: History
}

const SearchReadyNotificationModal: React.FC<IProps> = (props) => {
    const viewResult = () => {
        props.history.push(`${APP_PATH}result/${props.queue.ref}`);
        props.hide();
    }

    const renderContent = () => (
        <div>
            <span className="block my-5">
                Search Results{typeof props.queue.locationName !== 'undefined' ? ` for ${props.queue.locationName} ` : ' '}are ready to view.</span>
           <Button onClick={() => viewResult()} text="View" width="w-full" />
        </div>
    );

    return <BaseModal hide={props.hide} header="Results ready to view" content={renderContent()} />
}

export default SearchReadyNotificationModal;
